import { render, staticRenderFns } from "./GradeChanges.vue?vue&type=template&id=9636dd24&scoped=true"
import script from "./GradeChanges.vue?vue&type=script&lang=js"
export * from "./GradeChanges.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9636dd24",
  null
  
)

export default component.exports